var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.mobile
    ? _c(
        "div",
        {
          directives: [
            {
              name: "click-outside",
              rawName: "v-click-outside",
              value: _vm.close,
              expression: "close",
            },
          ],
          staticClass: "sort",
          class: _vm.opened ? "sort--opened" : "",
        },
        [
          _c(
            "div",
            { staticClass: "sort__list-header", on: { click: _vm.toggle } },
            [
              _vm._v("\n    Sortera på:\n    "),
              _c("span", {
                staticClass: "sort__arrow",
                class: _vm.opened
                  ? "sort__arrow--opened"
                  : "sort__arrow--closed",
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "ul",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.opened,
                  expression: "opened",
                },
              ],
              staticClass: "sort__list",
            },
            _vm._l(_vm.options, function (option) {
              return _c(
                "li",
                {
                  key: option.id,
                  staticClass: "sort__option",
                  class: {
                    "sort__option-selected": _vm.selected === option.id,
                  },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.select(option.id)
                    },
                  },
                },
                [_c("span"), _vm._v(_vm._s(option.name) + "\n    ")]
              )
            }),
            0
          ),
        ]
      )
    : _c("div", { staticClass: "mobile-filter__sort" }, [
        _c("p", { staticClass: "mobile-filter__sort-title" }, [
          _vm._v("Sortera på:"),
        ]),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "sort__list" },
          _vm._l(_vm.options, function (option) {
            return _c(
              "li",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.opened === true || _vm.mobile === true,
                    expression: "opened === true || mobile === true",
                  },
                ],
                key: option.id,
                staticClass: "sort__option",
                class: { "sort__option-selected": _vm.selected === option.id },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.select(option.id)
                  },
                },
              },
              [_c("span"), _vm._v(_vm._s(option.name) + "\n    ")]
            )
          }),
          0
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/Sort.vue